import React from 'react';

// HOC that returns a "wrapped" svg component with a div containing the passed
// in props.
//
// The `svg` props are passed down to the underlying SVG. Top level props are
// applied to the wrapping div.
//
// Usage:
//
// ```js
// import wrappedSvg from 'components/Images/wrappedSvg';
// import SvgComponent from 'components/Images/SvgComponent';
//
// const WrappedSvgComponent = wrappedSvg(SvgComponent);
//
// const NewComponentWithSvg = () => {
//   return (
//     ...
//     <WrappedSvgComponent className="someclass" svg={ propForSvg: 'x' } />
//     ...
//   )
// }

const wrappedSvg = (Component) => {
  const WrappedSvg = ({ svgProps, ...rest }) => {
    return (
      <div {...rest}>
        <Component {...svgProps} />
      </div>
    );
  };

  return WrappedSvg;
};

export default wrappedSvg;
